import { render, staticRenderFns } from "./AxRadioButton.vue?vue&type=template&id=58b85385&scoped=true"
import script from "./AxRadioButton.vue?vue&type=script&lang=ts"
export * from "./AxRadioButton.vue?vue&type=script&lang=ts"
import style0 from "./AxRadioButton.vue?vue&type=style&index=0&id=58b85385&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b85385",
  null
  
)

export default component.exports